import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs/Observable";
import {fromPromise} from "rxjs/observable/fromPromise";
import 'rxjs/Rx';
import {Subject} from "rxjs/Subject";
import {KeycloakService} from "../core/services/keycloak.service";
import {RaceCityService} from "../race/race-services/race-city.service";

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor{

  refreshTokenInProgress = false;
  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(){}

  updateToken(): Observable<any>{
    return fromPromise(new Promise((resolve, reject) => {
      KeycloakService.keycloak.updateToken(1).success(success => {
        resolve(KeycloakService.keycloak.token);
      }).error(error => reject('a'));
    }));
  }

  refreshToken(){
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    }else{
      this.refreshTokenInProgress = true;

      return this.updateToken()
        .do(() => {
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        });
    }
  }

  addAuthHeader(request){
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${KeycloakService.keycloak.token}`
      }
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(this.addAuthHeader(req));
    return next.handle(this.addAuthHeader(req)).catch( (error: HttpEvent<any>) => {
      if (error instanceof HttpErrorResponse) {
        if((<HttpErrorResponse>error).status==401){
          return this.refreshToken()
            .switchMap(() => {
              return next.handle(this.addAuthHeader(req));
            })
            .catch(() => {
              KeycloakService.keycloak.login();
              return Observable.empty();
            });
        }
        return Observable.throw(error);
      } else {
        return Observable.throw(error);
      }


    });
    //TODO - 401 error - refresh token - do przetestowania
  }

}



// WEBPACK FOOTER //
// ./src/app/interceptors/auth-token.interceptor.ts